var render = function render(){var _vm=this,_c=_vm._self._c;return _c('account-reset',{attrs:{"platform":"portal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }